/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

export const FlagPermissionUrgentDeliveryManagement = {
    permission_urgent_delivery_management_pod_enable: new FcsFlag.Flag(false),
    permission_urgent_delivery_management_rts_enable: new FcsFlag.Flag(false),
    permission_urgent_delivery_management_hal_enable: new FcsFlag.Flag(false),
    permission_urgent_delivery_management_taken_enable: new FcsFlag.Flag(false),
    permission_urgent_delivery_management_cari_enable: new FcsFlag.Flag(false),
    permission_urgent_delivery_management_relabel_enable: new FcsFlag.Flag(false),
};

export function initFlagPermissionUrgentDeliveryManagement() {
  FcsFlag.register("featureUrgentDeliveryManagement", FlagPermissionUrgentDeliveryManagement);
}
